// news公共方法
import Vue from 'vue';

// html 内容转纯文本
function ToText(HTML) {
    var input = HTML;
    return input
        .replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi, '')
        .replace(/<[^>]+?>/g, '')
        .replace(/\s+/g, ' ')
        .replace(/ /g, ' ')
        .replace(/&nbsp;/g, ' ')
        .replace(/>/g, ' ');
}


function look() {
    this.$get(`${this.$store.state.api.staFileUrl}/open/look.do?rowguid=${this.data.coverrowguid}` , data=>{
        // this.imgUrl = data.path;
        // this.matched.preview= data.path;
        // this.$forceUpdate();
        return data.path;
    })
}
//显示图片
function lookDo(rowguid , _staFileUrl) {
    if (!rowguid) return;
    // console.log(_this.$store.state.api.staFileUrl);
    Vue.prototype.$get(`${_staFileUrl}/open/look.do?rowguid=${rowguid}`, data => {
        console.log('lookDo', data);
        return data.path;
    });
}

export {
    ToText,
    lookDo,
}

